<app-loading-spinner *ngIf="isLoading"  [loadingTitle]="loadingTitle"
                     [loadingSubtitle]="loadingSubtitle"
                     [overlay]="true"></app-loading-spinner>
<app-notification-table [topics]="topics" [isLoading]="isLoading" (detail)="detail($event)"></app-notification-table>

